import React from 'react';
import { Redirect } from "react-router-dom";
import { isTablet } from "react-device-detect";
import { BASE_AXIOS } from "../config";

export const apiGetUserDetails = async (mcid, key, data) => {
    let form = new FormData();
    form.append("mcid", mcid);
    form.append("key", key);
    form.append("internal", true)

    if (typeof data !== 'undefined') {
        form.append("tracking", 1);
        form.append("pathname", data.pathname);
        form.append("pagevia", data.pagevia);
        form.append("action", data.action);
        form.append("os", data.os);
        form.append("ua", data.ua);
    } 

    try {
        const response = await BASE_AXIOS().request({
            method: "POST",
            params: {
                method: "getUserDetails"
            },
            data: form
        });

        if (typeof response.data === 'object' || Array.isArray(response.data)) {
            return response.data;
        } else if (typeof response.data === 'string') {
            return <Redirect to="/error"/>;
        }

    } catch (error) {
        throw error;
    }
};

export const apiUpdateNotification = async (data) => {
    let form = new FormData();
    form.append("mcid", data.mcid);
    form.append("key", data.key);
    form.append("pkid", data.pkid);
    form.append("state", data.state);

    if (typeof data.tracking !== 'undefined') {
        form.append("tracking", 1);
        form.append("pathname", data.tracking.pathname);
        form.append("pagevia", data.tracking.pagevia);
        form.append("action", data.tracking.action);
        form.append("os", data.tracking.os);
        form.append("ua", data.tracking.ua);
    } 

    let obj = {
        mcid:data.mcid,
        key:data.key,
        pkid:data.pkid,
        state:data.state,
    }

    try {
        const notifResults = await BASE_AXIOS().request({
            method: "POST",
            params: {
                method: "updateNotification"
            },
            data: form
        });

        return notifResults.data;
    } catch (e) {
        throw (e);
    } 
}

export const apiTrackPage = async (mcid, data) => {
    if (typeof mcid === 'undefined') {
        mcid = 'AUAUniversity App';
    }
    // console.log('\nDATA: ', data, `\nmcid: ${mcid}`); 
    let form = new FormData();
    form.append("tracking", 1);
    form.append("pathname", data.pathname);
    form.append("pagevia", data.pagevia);
    form.append("action", data.action);
    form.append("os", data.os);
    form.append("ua", data.ua);
    form.append("key", 1);
    form.append('internal', 1);
    form.append("mcid", mcid);

    if (typeof data.detail !== 'undefined') {
        form.append("detail", data.detail);
    }

    if (typeof data.detailvar !== 'undefined') {
        form.append("detailvar", data.detailvar);
    }

    try {
        let response = await BASE_AXIOS().request({
            method: "POST",
            params: {
                method: "trackUsage"
            },
            data: form
        });

        // console.log(response);

        return response.data;
    } catch (error) {
        throw error;
    }
}